import { useLocation } from "react-router-dom";
import QueryString from "query-string";

const useQueryParams = () => {
  const location = useLocation();
  return QueryString.parse(location.search);
};

export default useQueryParams;
